import React from "react";
import styles from "./key-account-filter.module.scss";
import { Autocomplete, Field, Filter, DateRange, Button } from "components/commons";
import { locale } from "localization/en";
import SearchTypeField from "components/commons/search-field/search-type";
import { Path } from "enums";
import { useRouter } from "hooks";
import { paymentMethod } from "data/constant/key-account-payment-methods";

const KeyAccountFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
}) => {
  const dateBy = [
    { label: locale.shiftDate, value: "shift" },
    { label: locale.collectionDate, value: "collection" },
  ];

  const searchType = [
    { label: locale.collectionId, value: "keyAccountCollectionId" },
    { label: locale.siNumSoa, value: "siNumber" },
    { label: locale.keyAccountName, value: "name" },
  ];

  const router = useRouter();

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            label={locale.filterDateBy}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="dateType"
              value={filterState.dateType}
              options={dateBy}
              onChange={(name, { value }) => {
                modifyFilter({ [name]: value });
              }}
              disableClearable={true}
            />
          </Field>
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.date}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            label={locale.paymentMethod}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name="paymentMethod"
              value={filterState.paymentMethod.value}
              options={paymentMethod}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({
                  [name]: {
                    value,
                    isSelectedAll,
                  },
                });
              }}
              multiple
              hasAll
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            // startIcon={<span className="icon-download" />}
            exportButton
            onClick={() => router.push(Path.AddKeyAccount)}
          >
            {locale.addKeyAccount}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default KeyAccountFilter;
